import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as NewClientSvg } from './new-client.svg';

export const NewClientIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <NewClientSvg />
    </SvgIcon>
  );
};
